module.exports = __webpack_public_path__ + "static/fonts/Simple-Line-Icons.78f07e2.woff";


//////////////////
// WEBPACK FOOTER
// ./~/simple-line-icons/fonts/Simple-Line-Icons.woff?v=2.4.0
// module id = 746
// module chunks = 85